// 接口文档
// const url = 'http:localhost:8000/'
const api = {
  // 查询内容
  getProjectList: "/api/zyqapi/baseinfo/getProjectList",
  getBannerList: "/api/zyqapi/baseinfo/getBannerList",
  getGroupLogic: "/api/zyqapi/baseinfo/getGroupLogic",
  getProjectMessageList: "/api/zyqapi/baseinfo/getProjectMessageList",
  getCourseSystem: "/api/zyqapi/baseinfo/getCourseSystem",
  getTrainCourseSystem: "/api/zyqapi/baseinfo/getTrainCourseSystem",
  getCourseList: "/api/zyqapi/baseinfo/getCourseList",
  getStatistics: "/api/zyqapi/baseinfo/getStatistics",
  getCustomColumnList: "/api/zyqapi/baseinfo/getCustomColumnList",
  getBaseInfo: "/api/zyqapi/baseinfo/getBaseInfo"
};
module.exports = api;
